const GET_TEST_QUESTION = 'DESK/ANSWER/GET_TEST_QUESTION';
const SAVE_TEST_QUESTION_ANSWER = 'DESK/ANSWER/SAVE_TEST_QUESTION_ANSWER';

export default {
  GET_TESTS_QUESTION: GET_TEST_QUESTION,
  SAVE_TEST_QUESTION_ANSWER,
};
